import { createSlice } from '@reduxjs/toolkit';
import { ResponseApi } from '../BaseApi';
import {
    PublicCreateRequestDocument
} from './RequestAccessApi';

/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */

const RequestAccessSlice = createSlice({
    name: 'request',
    initialState: {
        requestAccess: null,
        requestDocument: null,
        markAsRead :{}
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(PublicCreateRequestDocument.fulfilled, (state, { payload }) => {
                state.requestDocument = ResponseApi(payload);
            })
            .addCase("request/markFilesAsRead/fulfilled", (state, { payload }) => {
                state.markAsRead = ResponseApi(payload);
            })

    },
});

export default RequestAccessSlice.reducer;
